import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { MouseEvent, ReactElement } from 'react';
import { IBackNavigationProps } from '../containers/freeAccessNavigation.container';

export const BackToProjectDetailsButton = observer((props: IBackNavigationProps): ReactElement => {
  const { t } = useTranslator();

  const handleClick = (event: MouseEvent): void => {
    event.preventDefault();
    props.goTo(props.quitLink);
  };

  return (
    <Button
      tabIndex={-1}
      color='neutral'
      variant='topbar'
      onClick={handleClick}
      startDecorator={<FontAwesomeIcon icon={faArrowLeft} />}
    >
      {t('back')}
    </Button>
  );
});
